/**
 * Meeting event types for real-time notifications.
 */
export enum MeetingEventType {
  CREATED = 'meeting:created',
  UPDATED = 'meeting:updated',
  STARTED = 'meeting:started',
  ENDED = 'meeting:ended',
}

/**
 * Payload for meeting events.
 */
export interface MeetingEvent {
  type: MeetingEventType;
  meetingId: string;
  data: Record<string, unknown>;
  timestamp: string;
}

/**
 * Pub/sub channel for meeting events.
 */
export const MEETINGS_EVENTS_CHANNEL = 'meetings:events';

/**
 * Pub/sub channel for live meeting transcript segments (epic-4 O4-B).
 * Consumed by the gateway bridge → socket.io room `meetings:transcript-updates`.
 */
export const MEETINGS_TRANSCRIPT_CHANNEL = 'meetings:transcript';

/**
 * WebSocket room for meeting updates.
 */
export const MEETINGS_UPDATES_ROOM = 'meetings:updates';
